import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar'
import Contact from '../components/contact'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'

import bg from '../assets/images/hero/contacto.jpg'
import { Helmet } from 'react-helmet-async'

export default function Contactus() {
    const basedomain = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Contacto | Hospital Aranda de La Parra</title>
                <meta name="description" content="En Hospital Aranda de la Parra, estamos listos para brindarte la atención que necesitas. " />
                <meta property="og:title" content="Contacto | Hospital Aranda de La Parra" />
                <meta property="og:description" content="En Hospital Aranda de la Parra, estamos listos para brindarte la atención que necesitas. " />
                <meta property="og:image" content={`${basedomain}${bg}`} />
                <meta property="og:url" content={`${basedomain}/contacto`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Contacto | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="En Hospital Aranda de la Parra, estamos listos para brindarte la atención que necesitas. " />
                <meta name="twitter:image" content={`${basedomain}${bg}`} />
                <meta itemprop="name" content="Contacto | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="En Hospital Aranda de la Parra, estamos listos para brindarte la atención que necesitas. " />
                <meta itemprop="image" content={`${basedomain}${bg}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${bg})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Contacto</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Contacto</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>

            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <Contact />
            <section className="section pb-0 pt-0">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 p-0">
                            <div className="card map border-0">
                                <div className="card-body p-0">
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4807.161320824865!2d-101.68416112377942!3d21.125587980548026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842bbf0cfb3510db%3A0x4f041cca7c9d6540!2sHospital%20Aranda%20de%20la%20Parra!5e1!3m2!1ses-419!2smx!4v1731509700156!5m2!1ses-419!2smx" style={{ border: '0' }} allowFullScreen title="HAP"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
